import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
    const appReady = useSelector((state) => state.appReady);
    const signedInStatus = useSelector((state) => state.signedInStatus);

    if (!signedInStatus) {
        return null; // App.js handles showing login screen when not signed in
    }

    if (!appReady) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute; 